import React from "react";
import { Row, Col, Button } from "reactstrap";

const aulas = [
  {
    titulo: "AULA NOVA ATUALIZADA - AUTOMAPRO",
    descricao: "Aperte o PLAY para assistir!",
    video: "https://www.youtube.com/embed/Tb3ChkHJ3w8?si=qm96mh1ZtqY2cpxQ"
  },
  {
    titulo: "AULA 1 - Como funciona o Automahack",
    descricao: "Aperte o PLAY para assistir!",
    videoUrl: "https://www.youtube.com/embed/92HNBg7S6kk"
  },
  {
    titulo: "AULA 2 - Pegando vela 10X no Automahack",
    descricao: "Aperte o PLAY para assistir!",
    videoUrl: "https://www.youtube.com/embed/1wsYPTIp6bA?si=wR7aqyzHo8lBpNFH"
  },
  {
    titulo: "AULA 3 - Boas-Vindas ao mercado de iGaming",
    descricao: "Aperte o PLAY para assistir!",
    videoUrl: "https://www.youtube.com/embed/ToQT4bVv9Hk"
  },
  {
    titulo: "AULA 4 - A plataforma que eu opero e suas vantagens",
    descricao: "Aperte o PLAY para assistir!",
    videoUrl: "https://www.youtube.com/embed/6gBU6tQywGo"
  },
  {
    titulo: "AULA 5 - Como funciona o Aviator?",
    descricao: "Aperte o PLAY para assistir!",
    videoUrl: "https://www.youtube.com/embed/keUukI4llpo"
  },
  {
    titulo: "AULA 6 - Mantendo a consistência em jogos",
    descricao: "Aperte o PLAY para assistir!",
    videoUrl: "https://www.youtube.com/embed/06DuzYgLEcw"
  },
  {
    titulo: "BÔNUS - Mentalidade: A sua virada de chave",
    descricao: "Aperte o PLAY para assistir!",
    videoUrl: "https://www.youtube.com/embed/wYp4iaUjX6s"
  }
];

const Aulas = () => {
  return (
    <div className="content d-flex flex-column justify-content-center align-items-center">
      {/* Título principal */}
      <Row className="d-flex justify-content-center align-items-center text-center w-100 mx-auto mb-4">
        <Col xs={12}>
          <h2 className="title mt-4">Bem-vindo ao CURSO AVIATOR GRATUITO!</h2>
          <p>
            Aqui você vai aprender de uma forma gratuita a iniciar nesse
            mercado.
          </p>
        </Col>
      </Row>

      {/* Loop das aulas */}
      {aulas.map((aula, index) => (
        <Row
          key={index}
          className="d-flex justify-content-center align-items-center w-100 mx-auto mb-4"
        >
          <Col xs={12} md={8} className="text-center">
            <h3>{aula.titulo}</h3>
            <p>{aula.descricao}</p>
            <div className="video-container mb-4">
              <iframe
                className="video"
                width="100%"
                height="315"
                src={aula.videoUrl}
                title={aula.titulo}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default Aulas;
